// extracted by mini-css-extract-plugin
export default {"container":"SideMenu_container__-IdJ+","head":"SideMenu_head__uOyfq","menuItemsSection":"SideMenu_menuItemsSection__Euwx9"};